module.exports = __webpack_public_path__ + "static/media/d3.1e523b96.png";